<div class="dashboard--module-header">
    <h2 class="subheading-sm">Payment transmission performance <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<payment-transmission-performance-chart [(hasData)]="hasData" [(hasLoading)]="hasLoading" *ngIf="hasLoading || hasData; else noData" class="module--main"></payment-transmission-performance-chart>
<ng-template style="text-align:center" #noData><p class="text-center">No data available</p></ng-template>
